import React, { FC } from "react";
import styled from "styled-components";

const TabsWrapper: FC = (props) => {
  return <Wrapper>{props.children}</Wrapper>;
};

export default TabsWrapper;

const Wrapper = styled.div`
  justify-content: space-between;
  align-items: center;
  margin-left: -5px;
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    li {
      margin: 5px 5px;
    }
  }
  p.articles-count {
    margin-bottom: 0px;
    color: rgb(126, 126, 126);
    font-size: 14px;
    font-weight: 600;
    font-family: "robotomedium";
    white-space: nowrap;
    display: inline-block;
    float: right;
  }
`;
